/**
 * PostHog feature-flag keys, used for both server-side bootstrap evaluation
 * (`lib/server/posthog-bootstrap/middleware.js`) and client-side flag reads
 * via `posthog.getFeatureFlag(...)` / `posthog.isFeatureEnabled(...)`.
 *
 * Flag reload after identify() is disabled via `advanced_disable_feature_flags`
 * in the provider init — server-evaluated bootstrap values are the source of
 * truth. To add a new flag: register it in PostHog, add the key here, and add
 * the consumer's flag check inline.
 *
 * ⚠️ If a flag targets a PERSON PROPERTY (country, platform, an engagement
 * metric, etc.), that property MUST be supplied to `getAllFlags(...)` in the SSR
 * bootstrap (`lib/server/posthog-bootstrap/middleware.js`) — the single
 * flag-decision point. Adding the property only to the client `identify()` will
 * NOT gate the flag (identify does not re-evaluate flags). See
 * `lib/server/posthog-bootstrap/ARCHITECTURE.md`.
 */
// Co-located with the rest of the PostHog code so consumers find feature flags
// at the same barrel as the provider + hook. More named exports may be added
// (typed flag accessors, etc.); a default export would force anonymous imports.
// eslint-disable-next-line import/prefer-default-export
export const POSTHOG_FEATURE_FLAGS = {
  AI_GOTS: 'ai_gots',
  // Circles "My Circles" drawer rollout gate (replaces the hard-coded email
  // allowlist). Boolean flag; target the rollout cohort / emails in PostHog.
  COMMUNITY_CIRCLES_EMPLOYEE: 'community-circles-employee',
  // AI Video Guide Desktop Test - Segment Experiments
  AI_GUIDE_SEGMENT_A: 'ai-video-guide-desktop-a',
  AI_GUIDE_SEGMENT_B: 'ai-video-guide-desktop-b',
  AI_GUIDE_SEGMENT_C: 'ai-video-guide-desktop-c',
  AI_GUIDE_SEGMENT_D: 'ai-video-guide-desktop-d',
  // AI Video Guide Mobile Test - Segment Experiments
  AI_GUIDE_MOBILE_SEGMENT_A: 'ai-video-guide-mobile-a',
  AI_GUIDE_MOBILE_SEGMENT_B: 'ai-video-guide-mobile-b',
  AI_GUIDE_MOBILE_SEGMENT_C: 'ai-video-guide-mobile-c',
  AI_GUIDE_MOBILE_SEGMENT_D: 'ai-video-guide-mobile-d',
  // Divination cohort flags
  AI_DIVINATION_A: 'ai-divination-a',
  AI_DIVINATION_B: 'ai-divination-b',
  AI_DIVINATION_C: 'ai-divination-c',
  AI_DIVINATION_D: 'ai-divination-d',
  // AI-502: AI Search A/B experiment (multivariate: control/test)
  AI_SEARCH_WEB: 'ai-search-web',
  // AI-761: Daily Divination Card per-feature gates
  AI_DIVINATION_TAROT: 'ai-divination-tarot',
  AI_DIVINATION_ORACLE_CARDS: 'ai-divination-oracle',
  AI_DIVINATION_HOROSCOPE: 'ai-divination-horoscope', // planned — not yet live in PostHog
  // AI-1060: gate the assistant-message "Regenerate" button + variant navigator
  // on web while backend bugs are worked out. Boolean flag.
  AI_REGENERATE: 'ai-regenerate',
  // AI-1061: gate the message-pair Share button (sender side only — the public
  // /aichat/share/:shareId recipient page is never flag-gated). Boolean flag,
  // currently rolled out to the core dev team.
  AI_SHARE: 'ai-share',
}
